import React, {useState, useEffect} from 'react';
import {Environment} from '../environment/app-settings'



const getIsTabletOrDesktop = () => {
    return window.innerWidth >= Environment.tabletMinWidth
};

export default function useIsTabletOrDesktop() {
    const [isTabletOrDesktop, setIsTabletOrDesktop] = useState(getIsTabletOrDesktop);

    useEffect(() => {
        const onResize = () => {
            setIsTabletOrDesktop(getIsTabletOrDesktop());
        }

        window.addEventListener("resize", onResize);

        return () => {
            window.removeEventListener("resize", onResize);
        }
    }, []);

    return isTabletOrDesktop;
}